import { spError } from "@eventr/common";
import _ from "lodash";
import { bs, useBoundStore } from "../bound.store";
import { IItinerary } from "../interfaces";

export function migrateEventData(eventData: IItinerary, itineraryId: number) {
  if (!eventData || !eventData.v2 || eventData.v2.length === 0) {
    return;
  }

  const flightSection = eventData.v2.find((section) => {
    return section.sectionID === 2 && section.sectionName === "flights";
  });
  const hotelsSection = eventData.v2.find((section) => {
    return section.sectionID === 3 && section.sectionName === "accommodation";
  });
  const parkingSection = eventData.v2.find((section) => {
    return section.sectionID === 9 && section.sectionName === "parking";
  });
  const activitiesSection = eventData.v2.find((section) => {
    return section.sectionID === 8 && section.sectionName === "activities";
  });

  let migrate: boolean = false;
  const logTags = ["data", "migration"];

  function pushTag(tag: string) {
    if (!logTags.includes(tag)) {
      logTags.push(tag);
    }
  }

  if (flightSection && flightSection.data?.flights?.length > 0) {
    flightSection.data.flights.forEach((flight: any) => {
      if (flight.flight_date) {
        flight.flightDate = flight.flight_date;
        delete flight.flight_date;
        migrate = true;
        pushTag("flights");
      }
      if (flight.visibility) {
        switch (flight.visibility) {
          case "private":
            flight.visibility = "Private";
            migrate = true;
            pushTag("flights");
            break;
          case "team":
            flight.visibility = "Team";
            migrate = true;
            pushTag("flights");
            break;
          case "public":
            flight.visibility = "Public";
            migrate = true;
            pushTag("flights");
            break;
          default:
            break;
        }
      }
      if (flight.status) {
        switch (flight.status) {
          case "pending":
            flight.status = "Pending";
            migrate = true;
            pushTag("flights");
            break;
          case "confirmed":
            flight.status = "Confirmed";
            migrate = true;
            pushTag("flights");
            break;
          case "cancelled":
            flight.status = "Cancelled";
            migrate = true;
            pushTag("flights");
            break;
          default:
            break;
        }
      }
    });
  }

  if (hotelsSection && hotelsSection.data?.hotels?.length > 0) {
    hotelsSection.data.hotels.forEach((hotel: any) => {
      if (hotel.visibility) {
        switch (hotel.visibility) {
          case "private":
            hotel.visibility = "Private";
            migrate = true;
            pushTag("hotels");
            break;
          case "team":
            hotel.visibility = "Team";
            migrate = true;
            pushTag("hotels");
            break;
          case "public":
            hotel.visibility = "Public";
            migrate = true;
            pushTag("hotels");
            break;
          default:
            break;
        }
      }
      if (hotel.status) {
        switch (hotel.status) {
          case "pending":
            hotel.status = "Pending";
            migrate = true;
            pushTag("hotels");
            break;
          case "confirmed":
            hotel.status = "Confirmed";
            migrate = true;
            pushTag("hotels");
            break;
          case "cancelled":
            hotel.status = "Cancelled";
            migrate = true;
            pushTag("hotels");
            break;
          default:
            break;
        }
      }
      if (hotel.OSMAddress && hotel.OSMAddress.boundingbox) {
        if (!_.isArray(hotel.OSMAddress.boundingbox)) {
          try {
            hotel.OSMAddress.boundingbox = Object.values(hotel.OSMAddress.boundingbox);
          } catch (error) {
            spError(error);
            hotel.OSMAddress.boundingbox = [];
          }
          migrate = true;
          pushTag("hotels");
        }
      }
    });
  }

  if (activitiesSection && activitiesSection.data?.activities?.length > 0) {
    activitiesSection.data.activities.forEach((activity: any) => {
      if (activity.address && activity.address.boundingbox) {
        if (!_.isArray(activity.address.boundingbox)) {
          try {
            activity.address.boundingbox = Object.values(activity.address.boundingbox);
          } catch (error) {
            spError(error);
            activity.address.boundingbox = [];
          }
          migrate = true;
          pushTag("activities");
        }
      }
    });
  }

  if (parkingSection && parkingSection.data?.parkings?.length > 0) {
    parkingSection.data.parkings.forEach((parking: any) => {
      if (parking.address && parking.address.boundingbox) {
        if (!_.isArray(parking.address.boundingbox)) {
          try {
            parking.address.boundingbox = Object.values(parking.address.boundingbox);
          } catch (error) {
            spError(error);
            parking.address.boundingbox = [];
          }
          migrate = true;
          pushTag("parkings");
        }
      }
    });
  }

  if (migrate) {
    useBoundStore.setState(
      {
        itineraryData: {
          ...bs().itineraryData,
          // A new object, as subscribers compare the itinerary by identity.
          [itineraryId]: { ...eventData },
        },
      },
      false,
      "itineraryData updated",
    );
  }
}
